import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('MetadataInput')
@modelOptions({ schemaOptions: { strict: false } })
export class Metadata {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('meta') })
  _id: string
}

export type MetadataType = Metadata & Record<any, any>
